import type { Subscription } from '@/types/dtos/transactions/subscription.dto';
import type { SubscriptionTier } from '@/types/dtos/transactions/subscription-plan.dto';

export function findBookedEventSubscription(
  subscriptions: Subscription[] | undefined,
  subscriptionProductKey: string,
  scopeType: string,
  scopeId: string,
): Subscription | undefined {
  return subscriptions?.find((s) => {
    const key = s.subscriptionProductKey?.trim() || s.subscriptionPlan?.subscriptionProductKey?.trim();
    if (key !== subscriptionProductKey) return false;
    const st = s.scopeType?.trim() || 'Event';
    if (st !== scopeType) return false;
    const sid = s.scopeId != null ? String(s.scopeId) : '';
    // Legacy FREE rows may omit scopeId; treat as Event-scoped.
    if (!sid && scopeType === 'Event') return true;
    return sid === scopeId;
  });
}

export function tierFromEventSubscription(sub: Subscription | undefined): SubscriptionTier | null {
  if (!sub) return null;
  const tier = (sub.tier || sub.subscriptionPlan?.tier) as SubscriptionTier | undefined;
  return tier ?? null;
}

/** Cart line shape used by event subscription checkout. */
export type EventCartLineLike = {
  subscriptionProductKey: string;
  tier: string;
  scopeType?: string;
  scopeId?: string;
};

export function findEventCartLine(
  lines: EventCartLineLike[] | undefined,
  subscriptionProductKey: string,
  scopeType: string,
  scopeId: string,
): EventCartLineLike | undefined {
  return lines?.find((l) => {
    const key = String(l.subscriptionProductKey ?? '').trim();
    if (key !== subscriptionProductKey) return false;
    const st = String(l.scopeType ?? '').trim() || 'Event';
    if (st !== scopeType) return false;
    const sid = l.scopeId != null ? String(l.scopeId).trim() : '';
    // Legacy cart lines may omit scopeId; treat as Event-scoped.
    if (!sid && scopeType === 'Event') return true;
    return sid === scopeId;
  });
}
